export default __webpack_public_path__ + "static/media/sapphire_proj.51f7200c.png";